import { PhotoCaptions } from "@/types/common";

interface BuildPhotoCaptionsProps {
    pointName: string;
    taskName: string;
    userFullName: string;
    distance: string;
}

export const buildPhotoCaptions = ({
    pointName,
    taskName,
    userFullName,
    distance,
}: BuildPhotoCaptionsProps): PhotoCaptions => {
    return {
        topLines: [taskName, userFullName],
        bottomLines: [pointName, distance],
    };
};
